import { useEffect, useRef, useState } from 'react';
import { request } from './twinscope-api.js';
import { supervisorAccessLost } from './telemetry-access.js';
export function usePlantAlarms(records, enabled, onDenied) {
  const [snapshots, setSnapshots] = useState({});
  const denied = useRef(onDenied); denied.current = onDenied;
  const targets = JSON.stringify(records.flatMap(record => [...new Set(Object.values(record.document.twinIds || {}))].map(twin => [record.id, twin])));
  useEffect(() => {
    setSnapshots({});
    if (!enabled) return;
    let active = true, timer;
    const controller = new AbortController();
    const freshnessTimer = setInterval(() => { if (active) setSnapshots(value => ({ ...value })); }, 5000);
    async function poll() {
      const next = {};
      // Bounded request concurrency; map monitoring works without opening a Twin.
      const queue = JSON.parse(targets);
      await Promise.all(Array.from({ length: Math.min(3, queue.length) }, async () => {
        while (active && queue.length) {
          const [plant, twin] = queue.shift();
          const get = kind => request(`/api/twinscope/twins/${encodeURIComponent(twin)}/realtime/${kind}?plantId=${encodeURIComponent(plant)}&objectId=`, { signal: AbortSignal.any([controller.signal, AbortSignal.timeout(15000)]) });
          try {
            const status = await get('status');
            const latest = status.hasData || status.available ? await get('latest') : null;
            (next[plant] ||= {})[twin] = { status, latest, fetchedAt: Date.now() };
          } catch (error) {
            (next[plant] ||= {})[twin] = null;
            const lostAccess = active && await supervisorAccessLost(error, { signal: controller.signal });
            if (active && lostAccess) { active = false; controller.abort(); setSnapshots({}); denied.current(); }
          }
        }
      }));
      if (active) { setSnapshots(next); timer = setTimeout(poll, 10000); }
    }
    void poll();
    return () => { active = false; clearTimeout(timer); clearInterval(freshnessTimer); controller.abort(); };
  }, [targets, enabled]);
  return enabled ? snapshots : {};
}
